<script lang="ts">
	import ImageOptimiser from '$lib/components/common/ImageOptimiser.svelte';
	import { onMount, onDestroy } from 'svelte';
	import * as REVIEWERS from '$ravioli/lib/assets/images/reviews';
	import reviewVideo from '$ravioli/lib/assets/videos/review-video.mp4';
	import logo from '$ravioli/lib/assets/images/logo.png';
	import scrollRight from '$ravioli/lib/assets/icons/scroll-arrow-right.svg';
	import scrollLeft from '$ravioli/lib/assets/icons/scroll-arrow-left.svg';

	let sliderContainer: HTMLElement;
	let activeDot = 0;
	let canScrollLeft = false;
	let canScrollRight = true;

	let CustomerReviews = [
		{ image: REVIEWERS.lakshmi, name: 'Lakshmi Manchu', job: 'Tollywood Actress' },
		{ image: REVIEWERS.navdeep, name: 'Navdeep', job: 'Tollywood Actor' },
		{ image: REVIEWERS.tejasvi, name: 'Tejasvi madivada', job: 'Tollywood Actress' },
		{ image: REVIEWERS.navdeep2, name: 'Navdeep', job: 'Tollywood Actor' }
	];

	const scroll = (direction: 'left' | 'right') => {
		if (!sliderContainer) return;

		activeDot = direction === 'left' ? 0 : 1;

		const scrollAmount = 290 + 100; // card width + gap
		const scrollPosition =
			direction === 'left'
				? sliderContainer.scrollLeft - scrollAmount
				: sliderContainer.scrollLeft + scrollAmount;

		sliderContainer.scrollTo({
			left: scrollPosition,
			behavior: 'smooth'
		});
	};

	const updateScrollState = () => {
		if (sliderContainer) {
			const { scrollLeft, scrollWidth, clientWidth } = sliderContainer;

			// Update active dot
			activeDot = scrollLeft + clientWidth >= scrollWidth ? 1 : 0;

			// Check scroll capabilities
			canScrollLeft = scrollLeft > 0;
			canScrollRight = scrollLeft + clientWidth < scrollWidth;
		}
	};

	onMount(() => {
		if (sliderContainer) {
			sliderContainer.addEventListener('scroll', updateScrollState);
			window.addEventListener('resize', updateScrollState);
		}
	});

	onDestroy(() => {
		if (sliderContainer) {
			sliderContainer.removeEventListener('scroll', updateScrollState);
			window.removeEventListener('resize', updateScrollState);
		}
	});
</script>

<section class="font-roboto relative flex flex-col gap-8 overflow-hidden px-4 py-11 md:py-12">
	<div class="flex flex-col gap-5 md:gap-7">
		<p class="title-underline relative mx-auto max-w-fit text-xl font-medium uppercase md:text-2xl">
			Our ravioli friends
		</p>
		<p class="text-center text-base">
			While we are blessed & honored to be a part of your journey, we are glad to make a positive
			impact on you.
		</p>
	</div>
	<div class="relative flex justify-center px-10 md:mt-2">
		<img
			src={logo}
			alt="logo"
			class="absolute left-1/2 top-1/2 z-10 w-full -translate-x-1/2 -translate-y-1/2 transform opacity-[0.05] md:max-w-[800px]"
		/>
		<!-- svelte-ignore a11y_media_has_caption -->
		<video
			src={reviewVideo}
			controls
			class="md:aspect-none relative z-20 aspect-square rounded-[32px] bg-[#F9F9F9] md:max-h-[386px] md:w-full md:max-w-[512px]"
		></video>
	</div>
	<p class="text-center text-sm md:text-base">Every individual is a celebrity for Ravioli but some celebrities are little more than clients for us.</p>
	<div class="relative mx-auto mt-2 md:mt-9 md:max-w-[1032px]">
		<div class="absolute top-[50%] w-screen lg:w-full">
			<!-- Right Navigation Button -->
			<button
				class="swiper-button-next right-0 mr-4 !hidden  md:!flex lg:mr-0 !w-10 !h-10"
				class:disabled={!canScrollRight}
				style:opacity={canScrollRight ? '1' : '0.3'}
				aria-label="right navigation"
				on:click={() => canScrollRight && scroll('right')}
			><img class="w-full h-full object-cover" src="{scrollRight}" alt="scroll left"></button>

			<!-- Left Navigation Button -->
			<button
				class="swiper-button-prev !-left-5 !hidden md:!flex !w-10 !h-10"
				class:disabled={!canScrollLeft}
				style:opacity={canScrollLeft ? '1' : '0.3'}
				aria-label="left navigation"
				on:click={() => canScrollLeft && scroll('left')}
			><img class="w-full h-full object-contain " src="{scrollLeft}" alt="scroll left"></button>
		</div>

		<div
			bind:this={sliderContainer}
			class="hide-scrollbar flex w-full cursor-pointer flex-row flex-nowrap gap-5 overflow-x-auto px-4 md:gap-10 md:px-8"
		>
			{#each CustomerReviews as review}
				<div
					class="flex max-w-[152px] flex-none flex-col gap-2 overflow-hidden rounded-lg border-[0.5px] border-[#E9E8E7] bg-[#F7F7F6] pb-4 shadow-[0px_2px_8px_0px_rgba(0,_0,_0,_0.08)] md:max-w-[300px] md:gap-7 md:rounded-2xl"
				>
					<div
						class="max-h-[152px] overflow-hidden rounded-b-[72px] md:max-h-[300px] md:rounded-b-[150px]"
					>
						<ImageOptimiser
							src={review.image}
							alt="customer review images"
							imageSourceType="internal"
							classes={{ image: 'w-full h-full object-cover object-top' }}
						/>
					</div>
					<div class="flex flex-col text-center text-[10px]/4 md:gap-1 md:text-base">
						<p class="font-medium">{review.name}</p>
						<p>{review.job}</p>
					</div>
				</div>
			{/each}
		</div>

		<div class="pagination-dots mt-5 flex justify-center md:mt-10">
			{#each [0, 1] as _, i}
				<button
					class="dot"
					aria-label="pagination {i}"
					class:active={activeDot === i}
					on:click={() => scroll(i === 0 ? 'left' : 'right')}
				></button>
			{/each}
		</div>
	</div>
</section>
